import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/Context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Typography, Button } from "@mui/material";
import API_URL from "../../config";
import DocumentCard from "../../components/DocumentCard/DocumentCard";
import CompletedDocumentCard from "../../components/CompletedDocumentCard/CompletedDocumentCard";
import API_BASE_URL from "../../utils/api";
import {
  getDocCompletedPercent,
  isDocFullyCompleted,
} from "../../utils/progress";

const DocumentsList = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [activeDocuments, setActiveDocuments] = useState([]);
  const [completedDocuments, setCompletedDocuments] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const url = token
      ? `${API_BASE_URL}/documents`
      : `${API_BASE_URL}/documents/public/documents`;

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    axios
      .get(url, { headers })
      .then((res) => {
        const groupedDocuments = res.data.reduce((acc, doc) => {
          acc[doc.category] = acc[doc.category] || [];
          acc[doc.category].push(doc);
          return acc;
        }, {});
        setCategories(Object.entries(groupedDocuments));

        setActiveDocuments(res.data.filter((doc) => !isDocFullyCompleted(doc)));
        setCompletedDocuments(
          res.data.filter((doc) => isDocFullyCompleted(doc))
        );
      })
      .catch((err) => console.error("Error fetching documents:", err));
  }, []);

  return (
    <Box sx={{ padding: "5px" }}>
      <Typography
        variant="h4"
        sx={{
          marginBottom: "20px",
        }}
      >
        Explore topics
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          gap: "15px",
          marginTop: "10px",
        }}
      >
        {categories.length > 0 ? (
          categories.map(([category], index) => (
            <Button
              key={index}
              variant="contained"
              sx={{ backgroundColor: "#ffc107" }}
              onClick={() => navigate(`/transcription/${category}`)}
            >
              {category}
            </Button>
          ))
        ) : (
          <Typography>No categories found.</Typography>
        )}
      </Box>

      <Typography
        variant="h4"
        sx={{
          marginTop: "50px",

          paddingLeft: "10px",

          textAlign: "center",
        }}
      >
        Active Documents
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
        }}
      >
        {activeDocuments.length > 0 ? (
          activeDocuments.map((doc) => (
            <DocumentCard key={doc.documentId} doc={doc} />
          ))
        ) : (
          <Typography>No active documents.</Typography>
        )}
      </Box>

      <Typography
        variant="h4"
        sx={{
          marginTop: "50px",

          paddingLeft: "10px",

          textAlign: "center",
        }}
      >
        Completed Documents
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
        }}
      >
        {completedDocuments.length > 0 ? (
          completedDocuments.map((doc) => (
            <CompletedDocumentCard key={doc.documentId} doc={doc} />
          ))
        ) : (
          <Typography>No completed documents.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default DocumentsList;
